/* eslint-disable */
export default {
    invitation: "Einladung",
    inbox_invitation_description_text: "Wenn Sie \"zur Übersicht\" anklicken, werden Sie zum Programm weitergeleitet. Jeder Teil des Programms ist mit einer Anweisung und Zeitvorgabe versehen. Sie können zwischen den Teilen eine Pause machen.",
    inbox_complete_before: "Abrunden, bevor",
    inbox_invitation: "Einladung",
    inbox_organisation: "Organisation",
    inbox_start: "Zur Übersicht",
    inbox_no_messages_for_participant: "Es sind keine Berichte vorhanden",
    inbox_could_not_process_your_request: "Kann Ihre Anfrage nicht verarbeiten",
    inbox_page_title: "Inbox"
};
